<template>
  <div class="integralUser seller-style">
    <h2 class="f18 fb normal gray_2">积分管理-积分汇总</h2>
    <div class="box30"></div>
    <div>
      <div class="flex align_center">
        <div class="lable">客户：</div>
        <el-input class="w240" placeholder="请输入客户名称或联系电话" v-model.trim="selVal"></el-input>
        <div class="lable">时间：</div>
        <el-date-picker
          class="mar20_r"
          v-model="value"
          type="daterange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          popper-class="seller-style"
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
        <el-button type="primary" @click="getPointsDtl">查询</el-button>
      </div>
      <div class="box30"></div>
      <el-table border :data="list" row-class-name="pointer">
        <el-table-column show-overflow-tooltip prop="name" label="客户名称" min-width="15%" />
        <el-table-column show-overflow-tooltip prop="phone" label="联系电话" min-width="15%" />
        <el-table-column prop="grantPoints" label="收入" min-width="15%">
          <template slot="header">
            <span
              >收入
              <el-tooltip effect="dark" :content="'说明：积分收入包含积分获得、积分回退'" placement="top-start">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="usedPoints" label="支出" min-width="15%">
          <template slot="header">
            <span
              >支出
              <el-tooltip effect="dark" :content="'说明：积分支出包含积分消耗、积分过期'" placement="top-start">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
// import { mapState } from "vuex";

export default {
  data() {
    return {
      value: "",
      list: [],
      selVal: "",
    };
  },
  created() {
    this.formatDate();
    this.getPointsDtl();
  },
  mounted() {},
  methods: {
    getPointsDtl() {
      const params = {
        selVal: this.selVal,
        status: 1,
        timeStart: this.value ? this.value[0] : "",
        timeEnd: this.value ? this.value[1] : "",
        ptType: "collect",
      };
      this.$store.dispatch("points/points/getPointsByShopId", params).then((data) => {
        console.log(data);
        if (data) {
          this.list = data;
          let grantPointsAll = 0;
          let usedPointsAll = 0;
          this.list.forEach((key) => {
            grantPointsAll = Number(grantPointsAll) + Number(key.grantPoints);
            usedPointsAll = Number(usedPointsAll) + Number(key.usedPoints);
          });
          const totalData = {
            name: "总计",
            phone: "",
            grantPoints: grantPointsAll,
            usedPoints: usedPointsAll,
            isDel: 0,
          };
          this.list.push(totalData);
        }
      });
    },
    formatDate() {
      const date = new Date();
      if (date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1 <= 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const day = date.getDate() <= 9 ? `0${date.getDate()}` : date.getDate();
        this.value = [`${year}-${month}-${day} 00:00:00`, `${year}-${month}-${day} 23:59:59`];
      }
      return "";
    },
  },
  // 监听器
  filters: {},
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
